/**
 * 教材
 * 教材API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The TextbookCategoryEditForm model module.
   * @module textbook/model/TextbookCategoryEditForm
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>TextbookCategoryEditForm</code>.
   * @alias module:textbook/model/TextbookCategoryEditForm
   * @class
   * @param name {String} 分类名称
   * @param bookType {Integer} 类型 1:数字教材 2:电子书
   */
  var exports = function(name, bookType) {
    var _this = this;




    _this['name'] = name;
    _this['bookType'] = bookType;

  };

  /**
   * Constructs a <code>TextbookCategoryEditForm</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:textbook/model/TextbookCategoryEditForm} obj Optional instance to populate.
   * @return {module:textbook/model/TextbookCategoryEditForm} The populated <code>TextbookCategoryEditForm</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'pid')) {
        obj['pid'] = ApiClient.convertToType(data['pid'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'thumbUrl')) {
        obj['thumbUrl'] = ApiClient.convertToType(data['thumbUrl'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'name')) {
        obj['name'] = ApiClient.convertToType(data['name'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'bookType')) {
        obj['bookType'] = ApiClient.convertToType(data['bookType'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'sortKey')) {
        obj['sortKey'] = ApiClient.convertToType(data['sortKey'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * id
   * @member {Integer} id
   */
  exports.prototype['id'] = undefined;
  /**
   * pid
   * @member {Integer} pid
   */
  exports.prototype['pid'] = undefined;
  /**
   * 缩略图
   * @member {String} thumbUrl
   */
  exports.prototype['thumbUrl'] = undefined;
  /**
   * 分类名称
   * @member {String} name
   */
  exports.prototype['name'] = undefined;
  /**
   * 类型 1:数字教材 2:电子书
   * @member {Integer} bookType
   */
  exports.prototype['bookType'] = undefined;
  /**
   * 排序
   * @member {Integer} sortKey
   */
  exports.prototype['sortKey'] = undefined;



  export default exports;
;


